import { allIndividualPlans } from './plans';
import {
  businessAddonsUS,
  businessAddonsAU,
  businessAddonsCA,
  businessAddonsEU,
  businessAddonsGB,
  businessAddonsUSDMedium,
} from './addons';
import { toCurrency } from '../utils/to-currency';

export const weeklyCostB2c = {
  GB: '£1.25',
  US: '$2.75',
  EU: '€1.50',
  AU: 'A$4.00',
  CA: 'CA$3.75',
  AD: '$1.75',
  AF: '$1.75',
  AG: '$1.75',
  AL: '$1.75',
  AM: '$1.75',
  AO: '$1.75',
  AQ: '$1.75',
  AR: '$1.75',
  AW: '$1.75',
  AZ: '$1.75',
  BA: '$1.75',
  BB: '$1.75',
  BD: '$1.75',
  BF: '$1.75',
  BI: '$1.75',
  BJ: '$1.75',
  BM: '$1.75',
  BO: '$1.75',
  BQ: '$1.75',
  BR: '$1.75',
  BS: '$1.75',
  BT: '$1.75',
  BY: '$1.75',
  CD: '$1.75',
  CI: '$1.75',
  CL: '$1.75',
  CM: '$1.75',
  CN: '$1.75',
  CO: '$1.75',
  CR: '$1.75',
  CU: '$1.75',
  CV: '$1.75',
  CW: '$1.75',
  DO: '$1.75',
  DZ: '$1.75',
  EC: '$1.75',
  EG: '$1.75',
  EH: '$1.75',
  ET: '$1.75',
  FJ: '$1.75',
  FK: '$1.75',
  FM: '$1.75',
  FO: '$1.75',
  GA: '$1.75',
  GD: '$1.75',
  GE: '$1.75',
  GG: '$1.75',
  GH: '$1.75',
  GI: '$1.75',
  GM: '$1.75',
  GP: '$1.75',
  GQ: '$1.75',
  GR: '$1.75',
  GT: '$1.75',
  GU: '$1.75',
  HK: '$1.75',
  HN: '$1.75',
  HR: '$1.75',
  HT: '$1.75',
  ID: '$1.75',
  IL: '$1.75',
  IN: '$1.75',
  IQ: '$1.75',
  IR: '$1.75',
  IS: '$1.75',
  JE: '$1.75',
  JM: '$1.75',
  JO: '$1.75',
  JP: '$1.75',
  KE: '$1.75',
  KG: '$1.75',
  KH: '$1.75',
  KN: '$1.75',
  KR: '$1.75',
  KY: '$1.75',
  LA: '$1.75',
  LB: '$1.75',
  LC: '$1.75',
  LI: '$1.75',
  LK: '$1.75',
  LS: '$1.75',
  LT: '$1.75',
  LV: '$1.75',
  LY: '$1.75',
  MA: '$1.75',
  MC: '$1.75',
  MD: '$1.75',
  ME: '$1.75',
  MG: '$1.75',
  MK: '$1.75',
  ML: '$1.75',
  MM: '$1.75',
  MN: '$1.75',
  MO: '$1.75',
  MQ: '$1.75',
  MR: '$1.75',
  MT: '$1.75',
  MU: '$1.75',
  MV: '$1.75',
  MW: '$1.75',
  MX: '$1.75',
  MY: '$1.75',
  MZ: '$1.75',
  NA: '$1.75',
  NC: '$1.75',
  NE: '$1.75',
  NF: '$1.75',
  NG: '$1.75',
  NI: '$1.75',
  NP: '$1.75',
  NZ: '$1.75',
  PA: '$1.75',
  PE: '$1.75',
  PF: '$1.75',
  PG: '$1.75',
  PH: '$1.75',
  PK: '$1.75',
  PR: '$1.75',
  PS: '$1.75',
  PY: '$1.75',
  RE: '$1.75',
  RS: '$1.75',
  RU: '$1.75',
  RW: '$1.75',
  SC: '$1.75',
  SD: '$1.75',
  SG: '$1.75',
  SI: '$1.75',
  SK: '$1.75',
  SL: '$1.75',
  SM: '$1.75',
  SN: '$1.75',
  SO: '$1.75',
  SS: '$1.75',
  SV: '$1.75',
  SY: '$1.75',
  SZ: '$1.75',
  TD: '$1.75',
  TG: '$1.75',
  TH: '$1.75',
  TJ: '$1.75',
  TL: '$1.75',
  TN: '$1.75',
  TR: '$1.75',
  TV: '$1.75',
  TW: '$1.75',
  TZ: '$1.75',
  UA: '$1.75',
  UG: '$1.75',
  UY: '$1.75',
  UZ: '$1.75',
  VC: '$1.75',
  VE: '$1.75',
  VG: '$1.75',
  VI: '$1.75',
  VN: '$1.75',
  VU: '$1.75',
  XK: '$1.75',
  YE: '$1.75',
  YT: '$1.75',
  ZA: '$1.75',
  ZM: '$1.75',
  ZW: '$1.75',
  AE: '$2.75',
  BH: '$2.75',
  BN: '$2.75',
  BW: '$2.75',
  BZ: '$2.75',
  EE: '$2.75',
  GY: '$2.75',
  KW: '$2.75',
  KZ: '$2.75',
  LU: '$2.75',
  OM: '$2.75',
  QA: '$2.75',
  SA: '$2.75',
  SR: '$2.75',
  TM: '$2.75',
  TT: '$2.75',
  AT: '€1.50',
  BE: '€1.50',
  DK: '€1.50',
  FI: '€1.50',
  FR: '€1.50',
  DE: '€1.50',
  IE: '€1.50',
  NL: '€1.50',
  NO: '€1.50',
  PL: '€1.50',
  ES: '€1.50',
  SE: '€1.50',
  CH: '€1.50',
  CZ: '€1.50',
  HU: '€1.50',
  CY: '€1.50',
  PT: '€1.50',
  BG: '€1.50',
  RO: '€1.50',
} as {
  [countryCode: string]: string;
};

export const monthlyCostB2c = {
  GB: `£${toCurrency(allIndividualPlans['personal-v3-gbp'].price)}`,
  US: `$${toCurrency(allIndividualPlans['personal-v3-usd'].price)}`,
  EU: `€${toCurrency(allIndividualPlans['personal-v3-eur'].price)}`,
  AU: `A$${toCurrency(allIndividualPlans['personal-v3-aud'].price)}`,
  CA: `CA$${toCurrency(allIndividualPlans['personal-v3-cad'].price)}`,
  AD: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  AF: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  AG: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  AL: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  AM: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  AO: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  AQ: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  AR: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  AW: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  AZ: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  BA: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  BB: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  BD: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  BF: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  BI: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  BJ: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  BM: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  BO: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  BQ: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  BR: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  BS: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  BT: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  BY: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  CD: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  CI: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  CL: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  CM: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  CN: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  CO: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  CR: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  CU: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  CV: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  CW: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  DO: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  DZ: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  EC: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  EG: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  EH: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  ET: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  FJ: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  FK: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  FM: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  FO: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  GA: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  GD: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  GE: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  GG: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  GH: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  GI: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  GM: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  GP: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  GQ: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  GR: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  GT: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  GU: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  HK: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  HN: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  HR: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  HT: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  ID: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  IL: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  IN: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  IQ: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  IR: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  IS: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  JE: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  JM: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  JO: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  JP: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  KE: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  KG: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  KH: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  KN: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  KR: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  KY: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  LA: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  LB: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  LC: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  LI: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  LK: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  LS: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  LT: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  LV: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  LY: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  MA: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  MC: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  MD: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  ME: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  MG: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  MK: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  ML: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  MM: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  MN: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  MO: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  MQ: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  MR: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  MT: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  MU: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  MV: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  MW: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  MX: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  MY: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  MZ: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  NA: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  NC: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  NE: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  NF: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  NG: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  NI: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  NP: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  NZ: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  PA: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  PE: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  PF: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  PG: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  PH: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  PK: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  PR: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  PS: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  PY: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  RE: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  RS: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  RU: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  RW: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  SC: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  SD: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  SG: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  SI: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  SK: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  SL: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  SM: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  SN: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  SO: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  SS: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  SV: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  SY: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  SZ: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  TD: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  TG: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  TH: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  TJ: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  TL: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  TN: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  TR: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  TV: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  TW: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  TZ: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  UA: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  UG: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  UY: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  UZ: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  VC: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  VE: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  VG: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  VI: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  VN: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  VU: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  XK: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  YE: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  YT: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  ZA: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  ZM: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  ZW: `$${toCurrency(allIndividualPlans['personal-v3-usd-medium'].price)}`,
  AE: `$${toCurrency(allIndividualPlans['personal-v3-usd'].price)}`,
  BH: `$${toCurrency(allIndividualPlans['personal-v3-usd'].price)}`,
  BN: `$${toCurrency(allIndividualPlans['personal-v3-usd'].price)}`,
  BW: `$${toCurrency(allIndividualPlans['personal-v3-usd'].price)}`,
  BZ: `$${toCurrency(allIndividualPlans['personal-v3-usd'].price)}`,
  EE: `$${toCurrency(allIndividualPlans['personal-v3-usd'].price)}`,
  GY: `$${toCurrency(allIndividualPlans['personal-v3-usd'].price)}`,
  KW: `$${toCurrency(allIndividualPlans['personal-v3-usd'].price)}`,
  KZ: `$${toCurrency(allIndividualPlans['personal-v3-usd'].price)}`,
  LU: `$${toCurrency(allIndividualPlans['personal-v3-usd'].price)}`,
  OM: `$${toCurrency(allIndividualPlans['personal-v3-usd'].price)}`,
  QA: `$${toCurrency(allIndividualPlans['personal-v3-usd'].price)}`,
  SA: `$${toCurrency(allIndividualPlans['personal-v3-usd'].price)}`,
  SR: `$${toCurrency(allIndividualPlans['personal-v3-usd'].price)}`,
  TM: `$${toCurrency(allIndividualPlans['personal-v3-usd'].price)}`,
  TT: `$${toCurrency(allIndividualPlans['personal-v3-usd'].price)}`,
  AT: `€${toCurrency(allIndividualPlans['personal-v3-eur'].price)}`,
  BE: `€${toCurrency(allIndividualPlans['personal-v3-eur'].price)}`,
  DK: `€${toCurrency(allIndividualPlans['personal-v3-eur'].price)}`,
  FI: `€${toCurrency(allIndividualPlans['personal-v3-eur'].price)}`,
  FR: `€${toCurrency(allIndividualPlans['personal-v3-eur'].price)}`,
  DE: `€${toCurrency(allIndividualPlans['personal-v3-eur'].price)}`,
  IE: `€${toCurrency(allIndividualPlans['personal-v3-eur'].price)}`,
  NL: `€${toCurrency(allIndividualPlans['personal-v3-eur'].price)}`,
  NO: `€${toCurrency(allIndividualPlans['personal-v3-eur'].price)}`,
  PL: `€${toCurrency(allIndividualPlans['personal-v3-eur'].price)}`,
  ES: `€${toCurrency(allIndividualPlans['personal-v3-eur'].price)}`,
  SE: `€${toCurrency(allIndividualPlans['personal-v3-eur'].price)}`,
  CH: `€${toCurrency(allIndividualPlans['personal-v3-eur'].price)}`,
  CZ: `€${toCurrency(allIndividualPlans['personal-v3-eur'].price)}`,
  HU: `€${toCurrency(allIndividualPlans['personal-v3-eur'].price)}`,
  CY: `€${toCurrency(allIndividualPlans['personal-v3-eur'].price)}`,
  PT: `€${toCurrency(allIndividualPlans['personal-v3-eur'].price)}`,
  BG: `€${toCurrency(allIndividualPlans['personal-v3-eur'].price)}`,
  RO: `€${toCurrency(allIndividualPlans['personal-v3-eur'].price)}`,
} as {
  [countryCode: string]: string;
};

export const monthlyCostB2b = {
  GB: `£${toCurrency(businessAddonsGB.tier1.price)}`,
  US: `$${toCurrency(businessAddonsUS.tier1.price)}`,
  EU: `€${toCurrency(businessAddonsEU.tier1.price)}`,
  AU: `A$${toCurrency(businessAddonsAU.tier1.price)}`,
  CA: `CA${toCurrency(businessAddonsCA.tier1.price)}`,
  AD: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  AF: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  AG: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  AL: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  AM: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  AO: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  AQ: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  AR: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  AW: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  AZ: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  BA: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  BB: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  BD: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  BF: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  BI: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  BJ: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  BM: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  BO: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  BQ: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  BR: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  BS: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  BT: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  BY: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  CD: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  CI: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  CL: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  CM: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  CN: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  CO: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  CR: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  CU: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  CV: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  CW: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  DO: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  DZ: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  EC: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  EG: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  EH: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  ET: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  FJ: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  FK: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  FM: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  FO: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  GA: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  GD: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  GE: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  GG: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  GH: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  GI: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  GM: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  GP: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  GQ: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  GR: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  GT: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  GU: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  HK: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  HN: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  HR: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  HT: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  ID: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  IL: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  IN: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  IQ: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  IR: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  IS: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  JE: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  JM: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  JO: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  JP: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  KE: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  KG: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  KH: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  KN: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  KR: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  KY: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  LA: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  LB: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  LC: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  LI: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  LK: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  LS: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  LT: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  LV: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  LY: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  MA: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  MC: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  MD: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  ME: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  MG: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  MK: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  ML: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  MM: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  MN: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  MO: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  MQ: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  MR: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  MT: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  MU: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  MV: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  MW: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  MX: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  MY: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  MZ: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  NA: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  NC: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  NE: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  NF: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  NG: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  NI: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  NP: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  NZ: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  PA: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  PE: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  PF: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  PG: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  PH: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  PK: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  PR: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  PS: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  PY: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  RE: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  RS: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  RU: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  RW: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  SC: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  SD: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  SG: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  SI: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  SK: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  SL: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  SM: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  SN: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  SO: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  SS: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  SV: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  SY: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  SZ: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  TD: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  TG: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  TH: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  TJ: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  TL: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  TN: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  TR: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  TV: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  TW: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  TZ: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  UA: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  UG: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  UY: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  UZ: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  VC: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  VE: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  VG: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  VI: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  VN: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  VU: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  XK: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  YE: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  YT: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  ZA: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  ZM: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  ZW: `$${toCurrency(businessAddonsUSDMedium.tier1.price)}`,
  AE: `$${toCurrency(businessAddonsUS.tier1.price)}`,
  BH: `$${toCurrency(businessAddonsUS.tier1.price)}`,
  BN: `$${toCurrency(businessAddonsUS.tier1.price)}`,
  BW: `$${toCurrency(businessAddonsUS.tier1.price)}`,
  BZ: `$${toCurrency(businessAddonsUS.tier1.price)}`,
  EE: `$${toCurrency(businessAddonsUS.tier1.price)}`,
  GY: `$${toCurrency(businessAddonsUS.tier1.price)}`,
  KW: `$${toCurrency(businessAddonsUS.tier1.price)}`,
  KZ: `$${toCurrency(businessAddonsUS.tier1.price)}`,
  LU: `$${toCurrency(businessAddonsUS.tier1.price)}`,
  OM: `$${toCurrency(businessAddonsUS.tier1.price)}`,
  QA: `$${toCurrency(businessAddonsUS.tier1.price)}`,
  SA: `$${toCurrency(businessAddonsUS.tier1.price)}`,
  SR: `$${toCurrency(businessAddonsUS.tier1.price)}`,
  TM: `$${toCurrency(businessAddonsUS.tier1.price)}`,
  TT: `$${toCurrency(businessAddonsUS.tier1.price)}`,
  AT: `€${toCurrency(businessAddonsEU.tier1.price)}`,
  BE: `€${toCurrency(businessAddonsEU.tier1.price)}`,
  DK: `€${toCurrency(businessAddonsEU.tier1.price)}`,
  FI: `€${toCurrency(businessAddonsEU.tier1.price)}`,
  FR: `€${toCurrency(businessAddonsEU.tier1.price)}`,
  DE: `€${toCurrency(businessAddonsEU.tier1.price)}`,
  IE: `€${toCurrency(businessAddonsEU.tier1.price)}`,
  NL: `€${toCurrency(businessAddonsEU.tier1.price)}`,
  NO: `€${toCurrency(businessAddonsEU.tier1.price)}`,
  PL: `€${toCurrency(businessAddonsEU.tier1.price)}`,
  ES: `€${toCurrency(businessAddonsEU.tier1.price)}`,
  SE: `€${toCurrency(businessAddonsEU.tier1.price)}`,
  CH: `€${toCurrency(businessAddonsEU.tier1.price)}`,
  CZ: `€${toCurrency(businessAddonsEU.tier1.price)}`,
  HU: `€${toCurrency(businessAddonsEU.tier1.price)}`,
  CY: `€${toCurrency(businessAddonsEU.tier1.price)}`,
  PT: `€${toCurrency(businessAddonsEU.tier1.price)}`,
  BG: `€${toCurrency(businessAddonsEU.tier1.price)}`,
  RO: `€${toCurrency(businessAddonsEU.tier1.price)}`,
} as {
  [countryCode: string]: string;
};
